import { LENSSPECIFICATION_SET } from "../constants";

const defaultState = {
    payload: { rightEyeStrength: "",
    rightEyeCurve: "",
    rightEyeDiameter: "",
    rightEyeCylinder: "",
    rightEyeAxis: "",
    rightEyeAdd: "",
    rightEyeColor: "",
    rightEyePacket: "",
    leftEyeStrength: "",
    leftEyeCurve: "",
    leftEyeDiameter: "",
    leftEyeCylinder: "",
    leftEyeAxis: "",
    leftEyeAdd: "",
    leftEyeColor: "",
    leftEyePacket: "",
    }
};


export const lensSpecifications = (state = defaultState, action) => {    
    const { type, payload } = action;
    if (payload) {
        const { key, data } = payload;
        switch (type) {
            case LENSSPECIFICATION_SET:        
                return {     
                    ...state,                        
                    payload: {
                        ...state.payload,
                        [key]:                         
                            data,                        
                    },                  
                };
            default:
                return state;
        }
    }
    return state;    
    
};